import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import manageRolesActionCreators from "~/store/manageRoles/actions";
import { StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import roleSchema from "~/forms/RoleForm/roleSchema";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import manageRoleSelectors from "~/store/manageRoles/selectors";
import RoleForm from "~/forms/RoleForm";
import api from "~/lib/api";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const RoleUpdateModal = () => {
  const {
    t
  } = useTranslation();
  const role = useSelector(manageRoleSelectors.getSelected);
  const status = useSelector(manageRoleSelectors.getStatus);
  const error = useSelector(manageRoleSelectors.getError);
  const [authorities, setAuthorities] = useState([]);
  const roleId = role?.id || "";
  const dispatch = useDispatch();
  const defaultValues = {
    name: role?.name || "",
    description: role?.description || "",
    weight: role?.weight || 0,
    authorities: role?.authorities || []
  };
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    resolver: yupResolver(roleSchema),
    defaultValues
  });
  useEffect(() => {
    api.fetchManageCompanyAuthorities().then(response => {
      setAuthorities(response);
    });
  }, []);
  useEffect(() => {
    if (role) {
      reset(defaultValues);
    }
  }, [reset, roleId]);
  const onSubmit = handleSubmit(data => {
    if (roleId) {
      dispatch(manageRolesActionCreators.updateStarted(roleId, data, _ref => {
        let {
          data: newRole
        } = _ref;
        if (newRole) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("RoleUpdateModal.roleUpdated", {
              name: `${newRole.name}`
            }),
            timeout: 10000
          }));
        }
      }));
    }
  });
  const handleCancel = () => {
    dispatch(manageRolesActionCreators.actionChanged(undefined, undefined));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("RoleUpdateModal.updateRole"),
    onClose: handleCancel,
    maxWidth: "560px",
    fullWidth: true,
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(RoleForm, {
    control: control,
    watch: watch,
    setValue: setValue,
    authorities: authorities
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("RoleUpdateModal.saveRole")))));
};
export default RoleUpdateModal;